import { render, staticRenderFns } from "./Assigned-interim-reviewers-list.vue?vue&type=template&id=b658d262"
import script from "./Assigned-interim-reviewers-list.vue?vue&type=script&lang=js"
export * from "./Assigned-interim-reviewers-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports